import ENTITY_DATA from "../../../../data/index.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async () => {
        const mockData = ENTITY_DATA.getAll();
        APP_COMPONENTS.reOrderModal.showModal(mockData);
    }
};
